import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {upsertEntityCards} from '~entity/entity-card/entity-card.actions';
import {emptyCards, EntityCard} from '~entity/entity-card/entity-card.model';
import {List} from 'immutable';
import {CardGroupVo} from '~model/vo/card-group-vo';

@Injectable({providedIn: 'root'})
export class CardsService {

  private cardsState: EntityCard[] = [];

  constructor(
    private store: Store<EntityCard>
  ) {
  }

  inicializar(): void {
    this.cardsState = emptyCards();
    this.store.dispatch(upsertEntityCards({entities: this.cardsState}) as any);
  }

  processaIndicadores(res: CardGroupVo[]): void {
    const entities = emptyCards();
    if (res && !List(res).equals(this.cardsState)) {
      res.forEach(({descricao, id, itens}) => {
        const objAlterado = entities.find(e => e.id === id);
        if (objAlterado) {
          objAlterado.itens = itens.map(i => ({...i, icon: objAlterado.itens.find(e => e.descricao === i.descricao)?.icon}));
          objAlterado.descricao = descricao;
        }
      });
    }

    this.cardsState = entities;
    this.store.dispatch(upsertEntityCards({entities}) as any);
  }
}
